import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import type { FileData } from "@/services/files";
import type { NoteTemplate } from "@/common/types/notesTemplates";
import { t } from "i18next";
import { CardContentNote } from "./CardContentNote";
import { CardContentTemplateGenerating } from "@/pages/Visit/components/CardContentTemplateGenerating";

interface Props {
  file: FileData;
  notes: NoteTemplate[];
  refresh: () => void;
  isRegenerateEnabled: boolean;
}

export const VisitTemplateViewer = (props: Props): React.ReactNode => {
  console.log(props.notes.length);
  return (
    <Card className="rounded-lg">
      <CardHeader className="bg-grey-white rounded-t-lg p-0">
        <CardTitle className="text-lg font-bold p-6">
          {t("visit.components.visitTemplateViewer.title")}
        </CardTitle>
      </CardHeader>
      <CardContentTemplateGenerating
        file={props.file}
        isRegenerateEnabled={props.isRegenerateEnabled}
        refresh={props.refresh}
      />
      {props.notes.map((note, index) => (
        <CardContentNote key={index} note={note} refresh={props.refresh} />
      ))}
    </Card>
  );
};
